import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "File"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.275 6.975L14.025 1.725C13.8913 1.57686 13.6995 1.49465 13.5 1.5H6C5.17157 1.5 4.5 2.17158 4.5 3V21C4.5 21.8284 5.17157 22.5 6 22.5H18C18.8284 22.5 19.5 21.8284 19.5 21V7.5C19.5054 7.30052 19.4231 7.10869 19.275 6.975ZM13.5 3.29999L17.7 7.49999H13.5V3.29999ZM6 3.00002V21H18V9.00002H13.5C12.6716 9.00002 12 8.32845 12 7.50002V3.00002H6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/File.vue"]]);
